export var borderTokens = {
  width: {
    none: '0rem',
    thin: '.1rem',
    medium: '.2rem',
    thick: '.4rem'
  },
  radius: {
    none: '0rem',
    s: '.2rem',
    m: '.4rem',
    l: '.8rem',
    xl: '1.6rem',
    xxl: '2.4rem',
    circle: '100%'
  }
};